import * as React from "react";

export function useForceUpdate() {
  const [, setValue] = React.useState<number>(0);
  return () => setValue((value) => ++value);
}
